module.exports = __webpack_public_path__ + "media/images/logo-a468b3c7.jpeg";